/**
 * @generated SignedSource<<ab24aec7e6940f50db92c2609cfa28fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSeller_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSellerTitle_user">;
  readonly " $fragmentType": "SbSharedRelatedSeller_user";
};
export type SbSharedRelatedSeller_user$key = {
  readonly " $data"?: SbSharedRelatedSeller_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSeller_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedSellerTitle_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d2438cf3c74b7245f33d022e265afe57";

export default node;
